var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPremedicationMissing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6087_3751",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6087_3751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.97249 11.815C3.87882 11.7175 3.83199 11.6018 3.83199 11.4678C3.83199 11.3339 3.87882 11.2118 3.97249 11.1015L6.44549 8.6285L5.06274 7.265L4.41674 7.91125C4.3064 8.02142 4.18424 8.0765 4.05024 8.0765C3.91624 8.0765 3.80057 8.02142 3.70324 7.91125C3.59674 7.81758 3.54349 7.70283 3.54349 7.567C3.54349 7.431 3.59674 7.30983 3.70324 7.2035L5.70324 5.22275C5.80057 5.11242 5.91624 5.05725 6.05024 5.05725C6.18424 5.05725 6.3064 5.11242 6.41674 5.22275C6.51024 5.31625 6.55699 5.431 6.55699 5.567C6.55699 5.70283 6.51024 5.81758 6.41674 5.91125L5.75124 6.5765L7.13399 7.94L9.60699 5.467C9.71732 5.35667 9.83949 5.3015 9.97349 5.3015C10.1073 5.3015 10.223 5.35667 10.3205 5.467C10.4308 5.56433 10.486 5.68 10.486 5.814C10.486 5.948 10.4308 6.07008 10.3205 6.18025L9.76099 6.73425L16.559 13.5323C16.8782 13.8516 17.0377 14.2359 17.0377 14.6853C17.0377 15.1346 16.8782 15.5124 16.559 15.8188L15.8012 16.5823L19.834 20.6093H18.407L15.0877 17.29L14.3302 18.0535C14.0237 18.3598 13.6458 18.513 13.1965 18.513C12.7472 18.513 12.3628 18.3598 12.0435 18.0535L5.24549 11.2553L4.68599 11.815C4.57565 11.9213 4.45674 11.9745 4.32924 11.9745C4.20157 11.9745 4.08265 11.9213 3.97249 11.815ZM5.93399 10.567L12.732 17.365C12.8602 17.4803 13.0076 17.538 13.1742 17.538C13.3409 17.538 13.4884 17.4803 13.6167 17.365L15.8455 15.1113C15.9737 14.9958 16.0377 14.8515 16.0377 14.6785C16.0377 14.5053 15.9737 14.3611 15.8455 14.2458L14.4225 12.7977L12.8877 14.3323C12.7776 14.4388 12.6587 14.4929 12.531 14.4948C12.4035 14.4968 12.2929 14.4509 12.1992 14.3573C12.0891 14.2599 12.034 14.1443 12.034 14.0103C12.034 13.8763 12.0891 13.7541 12.1992 13.6438L13.734 12.1093L11.6377 10.0323L10.1032 11.567C10.0057 11.6605 9.88999 11.7073 9.75599 11.7073C9.62215 11.7073 9.50007 11.6605 9.38974 11.567C9.29607 11.4567 9.24924 11.3345 9.24924 11.2005C9.24924 11.0665 9.29607 10.9508 9.38974 10.8535L10.9242 9.31875L9.05324 7.44775L5.93399 10.567ZM5.93399 10.567L6.05899 10.442C6.14232 10.3587 6.24807 10.2528 6.37624 10.1245L9.05324 7.44775L5.93399 10.567Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 11C21.5376 11 24 8.53757 24 5.5C24 2.46243 21.5376 0 18.5 0C15.4624 0 13 2.46243 13 5.5C13 8.53757 15.4624 11 18.5 11ZM17.95 6.60001V9.90001L21.8 4.40001H19.05V1.10001L15.2 6.60001H17.95Z",
    fill: "#FFC000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremedicationMissing);
export default __webpack_public_path__ + "static/media/premedication_missing.2d22d7e73dfbd0617f980ae1d7494503.svg";
export { ForwardRef as ReactComponent };